import { defineStore } from "pinia";
import { onMounted, onBeforeMount, reactive, ref, toRefs } from "vue";

// import { useSocketFn } from "./Fn/useSocket.js";

const useDeviceStore = defineStore("device", () => {
  //设备页面是否需要更新
  let updateDevicePage = ref(false);
  function changeUpdateDevicePage() {
    updateDevicePage.value = !updateDevicePage.value;
  }

  let fullScreenShow = ref(false);

  function changefullScreenShow() {
    fullScreenShow.value = !fullScreenShow.value;
  }

  let pageTitle = ref("通用后台管理系统");
  function updataPageTitle(res) {
    pageTitle.value = res;
  }

  function useDynamicTitle(modelName, iconUrl) {
    document.title = modelName || import.meta.env.VITE_APP_TITLE;
    changeFavicon(import.meta.env.VITE_APP_BASE_API + iconUrl);
  }

  // 修改图标
  function changeFavicon(iconUrl) {
    var link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = iconUrl;
    document.getElementsByTagName("head")[0].appendChild(link);
  }

  let deviceDta = ref({
    deviceId: null,
  });

  let currentWarehouse = ref(null);

  return {
    fullScreenShow,
    changefullScreenShow,
    updateDevicePage,
    changeUpdateDevicePage,
    pageTitle,
    updataPageTitle,
    deviceDta,
    useDynamicTitle,
    currentWarehouse,
  };
});

export default useDeviceStore;
